<template>
  <Dialog :open="true">
    <DialogContent no-overlay persistent class="w-auto md:max-w-fit min-w-[280px]">
      <DialogTitle class="hidden"></DialogTitle>
      <router-view />
    </DialogContent>
  </Dialog>
</template>
<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogTitle
} from '@/components/ui/dialog'
</script>
